'use strict';

var $d = require('../dependency');
var _ = $d._;

exports.transformResponseToObject = transformResponseToObject;

function transformResponseToObject(context, config, next) {
  var apiParsedResponseList = context.apiParsedResponseList,
    apiMergedResponse = {};

  //perform after afterApiAggregation
  ////!ToDo eliminate this forEach
  _.forEach(context.dataConfig, function (queryParams, index) {
    //Merge the API response list into a single object
    _.assign(apiMergedResponse, apiParsedResponseList[index]);
  });

  context.apiMergedResponse = apiMergedResponse;
  next();
}